'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const CollapsibleContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CollapsibleContext.displayName = "CollapsibleContext";
export function useCollapsibleContext() {
  const context = React.useContext(CollapsibleContext);
  if (context === undefined) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X: Missing context. Collapsible subcomponents must be placed within a <Collapsible /> component.' : _formatErrorMessage(114));
  }
  return context;
}